import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { companyInfo, serviceAreas } from '../../data/content';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <SafeIcon name="Droplet" className="text-2xl text-secondary" />
            <span className="text-xl font-bold text-white">BlueFlow Plumbing</span>
          </div>
          <p className="text-sm mb-4">Fast, reliable, and honest plumbing services for residential and commercial properties across the Greater Montreal Area.</p>
          <div className="flex gap-4">
             <SafeIcon name="Facebook" className="hover:text-white cursor-pointer" />
             <SafeIcon name="Instagram" className="hover:text-white cursor-pointer" />
          </div>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Contact Us</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <SafeIcon name="MapPin" className="mt-1 text-secondary shrink-0" />
              <span>{companyInfo.address}</span>
            </li>
            <li className="flex items-center gap-2">
              <SafeIcon name="Phone" className="text-secondary shrink-0" />
              <a href={`tel:${companyInfo.phone.replace(/\D/g,'')}`} className="hover:text-white">{companyInfo.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <SafeIcon name="Mail" className="text-secondary shrink-0" />
              <a href={`mailto:${companyInfo.email}`} className="hover:text-white">{companyInfo.email}</a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white">Our Services</Link></li>
            <li><Link to="/emergency" className="hover:text-white text-accent font-medium">24/7 Emergency</Link></li>
            <li><Link to="/financing" className="hover:text-white">Financing Options</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/request-service" className="hover:text-white">Book Online</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Service Areas</h3>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {serviceAreas.slice(0, 8).map(area => (
              <li key={area}><Link to="/areas" className="hover:text-white">{area}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-8 border-t border-slate-800 text-sm text-center">
        <p>&copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved. RBQ: 5555-5555-55(demo)</p>
      </div>
    </footer>
  );
}